module.exports = __webpack_public_path__ + "img/img-ticket-1.b6e984cd.png";